import React from 'react';
import { useAnalytics } from '../../components';
import { renderViewModel } from '../../render-view-model';
import { LinkBlockContainer, LinkBlockAnchor, LinkBlockAnchorChild } from './UiLinkBlock.styles';
export default function UiLinkBlock({ model }) {
    const { sendTrackEvent } = useAnalytics();
    const { block, lift, lighten, title, url } = model.content;
    return (React.createElement(LinkBlockContainer, { "data-testid": "ui-link-block", lift: lift, lighten: lighten },
        React.createElement(LinkBlockAnchor, { href: url, ariaLabel: title, onClick: () => sendTrackEvent('clickedUiLinkBlock', {
                event: 'clicked',
                eventComponent: 'linkBlock',
                eventContainer: 'content',
                label: title,
                uuid: model.id,
                href: url
            }), "data-uuid": model.id },
            React.createElement(LinkBlockAnchorChild, null)),
        renderViewModel(block)));
}
//# sourceMappingURL=UiLinkBlock.js.map